module.exports = "<div class=\"form-group\">\n  <label *ngIf=\"!removeLabel\">{{label}}</label>\n  <select type=\"text\" class=\"form-control {{classCampo}}\" [disabled]=\"desativado\">\n  </select>\n  <div class=\"alert alert-danger {{classError}}\" role=\"alert\" style=\"display: none;\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/campo-select2/campo-select2.component.html
// module id = ./src/app/shared/componentes/campo-select2/campo-select2.component.html
// module chunks = main